import React from 'react';

import Content from '@components/Dashboard/AdminPanel/StorePlan';

const StorePlan: React.FC = () => {
  return <Content />;
};

export default StorePlan;
